module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/contact_collector-5edd2ca1366aef34328e762c2dfcc6f7.webp";